exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-list[data-v-24ac97af] {\n  max-height: 204px;\n  overflow-y: auto;\n}\n.filter-list li input[data-v-24ac97af] {\n  cursor: pointer;\n}\n.filter-search[data-v-24ac97af] {\n  width: 100%;\n  padding: 5px;\n  margin-bottom: 10px;\n  box-sizing: border-box;\n}\n", ""]);

// exports
